import { createContext } from "react";
import useLotNotesByLotId from "../hooks/data/useLotNotesByLotId";

export interface ILotNotesContext extends ReturnType<typeof useLotNotesByLotId> {

};

const LotNotesContext = createContext<ILotNotesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default LotNotesContext